import StrongMindBody from '../../pages/strong-mind-body/StrongMindBody'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.STRONG_MIND_BODY, component: StrongMindBody },
])
